import React from 'react';
import { View } from 'react-native';
export default () => <View />;
